export default "__VITE_ASSET__9Q7LqPMU__"